export const averageTicketMessages = {
	MSG_CONFIRM_RECALCULATE: 'Deseja realmente recalcular o preço médio?',
	MSG_CONFIRM_RECALCULATE_PRODUCT_CHANNEL:
		'Deseja realmente recalcular o preço médio deste produto neste canal de venda?',
	MSG_RECALCULATE_DESCRIPTION:
		'Deseja realmente recalcular o preço médio? Caso deseje prosseguir, selecione o intervalo de tempo do histórico de vendas que deseja considerar no recálculo do preço médio:',
	MSG_RECALCULATE_PRODUCT_CHANNEL_DESCRIPTION_1:
		'Você está prestes a recalcular o valor do preço médio deste produto neste canal de venda.',
	MSG_RECALCULATE_PRODUCT_CHANNEL_DESCRIPTION_2:
		'O cálculo irá considerar o período de histórico de vendas definido nas configurações gerais da Easy360.',
	MSG_RECALCULATE_PRODUCT_CHANNEL_DESCRIPTION_3:
		'Caso o produto não possua vendas neste canal de venda no período de tempo informado, será removido o valor de preço médio.',
	MSG_RECALCULATE_PRODUCT_CHANNEL_DESCRIPTION_4:
		'No entanto, não se preocupe, você poderá cadastrar o preço médio do produto novamente, caso seja necessário. Deseja prosseguir com o recálculo?',
	MSG_WARNING_NEGATIVE_AVERAGE_TICKET:
		'Notamos que existe algum preço médio negativo na sua base, isso indica um grande volume de devoluções de vendas!',
	MSG_ERROR_NO_BASE_DATA:
		'Por favor, clique em Recalcular para obter os valores de preço médio.',
	MSG_EDIT_AVERAGE_TICKET_INSTRUCTION:
		'Por favor, insira o valor considerado para o preço médio.',
	MSG_SUCCESS_AVERAGE_TICKET_CREATED: {
		title: 'Registrado com sucesso!',
		text: 'Preço Médio registrado com sucesso.',
		status: 'success',
	},
	MSG_ERROR_AVERAGE_TICKET_CREATED: {
		title: 'Erro ao registrar Preço Médio!',
		text: 'Não foi possível registrar o Preço Médio.',
		status: 'error',
	},

	MSG_AVERAGE_TICKET_RECALCULATED: {
		title: 'Preço médio recalculado!',
		text: 'O preço médio foi recalculado com sucesso.',
		status: 'success',
	},
	MSG_ERROR_AVERAGE_TICKET_RECALCULATED: {
		title: 'Erro ao recalcular preço médio!',
		text: 'Não foi possível recalcular o preço médio.',
		status: 'error',
	},
	MSG_AVERAGE_TICKET_UPDATED: {
		title: 'Atualizado com sucesso!',
		text: 'Preço Médio atualizado com sucesso.',
		status: 'success',
	},
	MSG_ERROR_AVERAGE_TICKET_UPDATED: {
		title: 'Erro ao atualizar Preço Médio!',
		text: 'Não foi possível atualizar o Preço Médio.',
		status: 'error',
	},

	LABELS: {
		CANCEL_BUTTON: 'Cancelar',
		CONFIRM_BUTTON: 'Confirmar',
		SAVE_BUTTON: 'Salvar',
		EDIT_BUTTON: 'Editar',
		RECALCULATE_BUTTON: 'Recalcular',
		REGISTER_AVERAGE_TICKET_BUTTON: 'Cadastrar Preço Médio',
		PRODUCT: 'Produto',
		AVERAGE_TICKET: 'Preço Médio',
		SALES_CHANNEL: 'Canal de venda',
		FAMILY: 'Família',
		TIME_INTERVAL: 'Intervalo de Tempo',
		SELECT_TIME_INTERVAL: 'Selecione um intervalo de tempo',
		FULL_HISTORY: 'Histórico Completo',
	},

	PLACEHOLDER: {
		SELECT_TIME_INTERVAL: 'Selecione um intervalo de tempo',
	},

	SCREEN_TITLES: {
		EDIT_AVERAGE_TICKET: 'Editar Preço Médio',
		REGISTER_AVERAGE_TICKET: 'Cadastrar Preço Médio',
		RECALCULATE_AVERAGE_TICKET: 'Recalcular Preço Médio',
		AVERAGE_TICKET: 'Preço Médio',
	},
} as const;

export type AverageTicketMessageType =
	(typeof averageTicketMessages)[keyof typeof averageTicketMessages];
